import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tabs-with-content',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './tabs-with-content.component.html',
  styleUrl: './tabs-with-content.component.scss'
})
export class TabsWithContentComponent {
  @Output() onSelectTab = new EventEmitter<string>();
  @Input() tabs!: string[];
  @Input() selectedTab!: string;


  selectTab(tab: string) {
    this.onSelectTab.emit(tab);
  }

}
